import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { HttpEventType, HttpEvent } from "@angular/common/http";
import { ApiClientService } from "@shared/_services/api-client.service";
import { NgxPaginationModule } from "ngx-pagination";
import { ToastrModule } from 'ngx-toastr';
import { ToastrService } from 'ngx-toastr';
import Swal from "sweetalert2";
import { RouterModule } from '@angular/router';
import { PreloaderComponent } from '@app/modules/utils/preloader/preloader.component';
import { ActivatedRoute } from '@angular/router';
import { SearchService } from '@app/shared/_services/search.service';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'app-itag-tip-users',
  standalone: true,
  imports: [CommonModule, FormsModule, ToastrModule, NgxPaginationModule, RouterModule, PreloaderComponent],
  providers: [
    ToastrService,
  ],
  templateUrl: './itag-tip-users.component.html',
  styleUrls: ['./itag-tip-users.component.css']
})
export class ItagTipUsersComponent {
  public searchQuery: string = '';
  public openMenuId: string | null = null;

  public loading: boolean = false;
  public hasError: boolean = false;
  public errorMsg: string = '';
  public users: any = [];
  public totalItems: number = 0;
  public currentPage: number = 1;
  public pageSize: number = 10;

  constructor(private _apiClientService: ApiClientService,
    private _toastrService: ToastrService,
    private _searchService: SearchService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.getAllUsers();

    this.route.queryParams.subscribe(params => {
      const searchTerm = params['search'];
      if (searchTerm) {
        this.searchQuery = searchTerm;
        this.onSearch(searchTerm);
      } else {
        this.searchQuery = '';
        this.getAllUsers();
      }
    });
  }

  onSearch(term: string) {
    console.log("termed", term);
    if (term && term.trim() !== '') {
      this.loading = true;
      this.hasError = false;
      this.errorMsg = '';
      this.searchQuery = term;
      this.currentPage = 1;

      this._searchService.search(term.trim()).subscribe({
        next: (users: any[]) => {
          this.loading = false;
          this.users = users;
          this.totalItems = (users || []).length;
        },
        error: (error) => {
          this.loading = false;
          this.hasError = true;
          this.errorMsg = error?.message || 'Something went wrong during search.';
        }
      });
    } else {
      this.getAllUsers();
    }
  }

  onSearchInputChanged() {
    const trimmed = this.searchQuery.trim();
    if (trimmed === '') {
      this.getAllUsers();
    }
  }



  // onSearch(term: string) {
  //   if (term) {
  //     this.loading = true;
  //     this.hasError = false;
  //     this.errorMsg = '';
  //     this.searchQuery = term;

  //     // Using your existing ApiClientService
  //     this._apiClientService.readAllApiService(`user/search-user?searchInput=${term}`)
  //       .then((observable: Observable<HttpEvent<any>>) => {
  //         observable.subscribe(
  //           (event: HttpEvent<any>) => {
  //             switch (event.type) {
  //               case HttpEventType.Sent:
  //                 this.loading = true;
  //                 break;
  //               case HttpEventType.Response:
  //                 this.loading = false;
  //                 const { status, error, message, data, totalPages, count } = event.body;
  //                 if (status === 200) {
  //                   this.users = data;
  //                   this.totalItems = count;
  //                 } else {
  //                   this.hasError = true;
  //                   this.errorMsg = error || message || 'Failed to fetch search results';
  //                 }
  //             }
  //           },
  //           (error: any) => {
  //             this.loading = false;
  //             this.hasError = true;
  //             this.errorMsg = error.error?.message || error.message || 'Failed to fetch search results';
  //           }
  //         );
  //       })
  //       .catch((error: any) => {
  //         this.loading = false;
  //         this.hasError = true;
  //         this.errorMsg = error.message || 'An error occurred while searching';
  //       });
  //   } else {
  //     // If search is cleared, get all users
  //     this.getAllUsers();
  //   }
  // }

  public async getAllUsers() {
    this.loading = true;
    (await this._apiClientService.readAllApiService(`admin/itt-user/login/history?page=${this.currentPage}&pageSize=${this.pageSize}`)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            let { status, error, message, data, totalPages, count } = event.body;
            //if (status == 200) {

            this.totalItems = count;
            this.users = data;
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  private compare(a: any, b: any): any {
    const bandA = a.order;
    const bandB = b.order;

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  public async addUser(region: any) {
    this.loading = true;
    (await this._apiClientService.addApiService('region', region)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            console.log("User Added ", event.body);
            let { status, error, message, data } = event.body;
            this._toastrService.success('Success', 'Added User Successfully');
            //if (status == 200) {
            this.getAllUsers();
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  public async updateUser(region: any) {
    this.loading = true;
    (await this._apiClientService.updateApiService(`region`, region.id, region)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            console.log("User Updated ", event.body);
            this._toastrService.success('Success', 'Updated User Successfully');
            let { status, error, message, data } = event.body;
            //if (status == 200) {
            this.getAllUsers();
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  triggerDelete(user: any) {
    console.log(user);
    Swal.fire({
      title: 'Delete User',
      text: `Do you want to delete ${user.name}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete User',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#9b9b9b',
    }).then((result: any) => {
      /* Read more about isConfirmed, isDenied below */
      console.log(result.isConfirmed);
      if (result.isConfirmed) {
        console.log(result);
        this.deleteUser(user);
      }
    });
  }

  public async deleteUser(user: any) {
    this.loading = true;
    (await this._apiClientService.deleteApiService(`admin/itt-user`, user._id)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            console.log("User Deleted ", event.body);
            this._toastrService.success('Success', 'Deleted User Successfully');
            let { status, error, message, data } = event.body;
            //if (status == 200) {
            this.getAllUsers();
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message || errorObj?.error?.message;
        this._toastrService.error(
          errorMsg || 'Something went wrong. Please contact Technical Support.',
          'Delete Failed'
        );
      }
    );
  }

  triggerDisable(user: any) {
    Swal.fire({
      title: 'Disable User',
      text: `Do you want to disable ${user.name}? They will be logged out of all devices.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: 'Yes, Disable User',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#f59e0b',
      cancelButtonColor: '#9b9b9b',
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.updateUserStatus(user, 'Suspended');
      }
    });
  }

  triggerEnable(user: any) {
    Swal.fire({
      title: 'Enable User',
      text: `Do you want to enable ${user.name}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: 'Yes, Enable User',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#10b981',
      cancelButtonColor: '#9b9b9b',
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.updateUserStatus(user, 'Active');
      }
    });
  }

  public async updateUserStatus(user: any, status: string) {
    this.loading = true;
    (await this._apiClientService.patchApiService(`admin/itt-user`, `${user._id}/status`, { status })).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            if (status === 'Suspended') {
              this._toastrService.success(`${user.name} has been disabled.`, 'User Disabled');
            } else {
              this._toastrService.success(`${user.name} has been enabled.`, 'User Enabled');
            }
            this.getAllUsers();
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message || errorObj?.error?.message;
        this._toastrService.error(
          errorMsg || 'Something went wrong. Please contact Technical Support.',
          'Update Failed'
        );
      }
    );
  }

  public renderPage(event: number) {
    window.scroll(0, 0);
    console.log(event);
    this.currentPage = event;
    this.getAllUsers();
  }

  toggleMenu(userId: string) {
    this.openMenuId = this.openMenuId === userId ? null : userId;
  }

  closeMenu() {
    this.openMenuId = null;
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.openMenuId = null;
  }



}
